import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, Provider } from '@angular/core';
import { TokenStorageService } from '@modules/users/services/token-storage.service';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private tokenStorageService: TokenStorageService) {}
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = this.tokenStorageService.getToken();
    if (!token) {
      return next.handle(req);
    }
    const headers = req.headers.set('Authorization', `Bearer ${token}`);
    return next.handle(
      req.clone({
        headers,
      })
    );
    // return of('BEARER_TOKEN').pipe(
    //   take(1),
    //   switchMap((token) => {
    //     if (!token) {
    //       return next.handle(req);
    //     }

    //     const headers = req.headers.set('Authorization', `Bearer ${token}`);
    //     return next.handle(req.clone({
    //       headers
    //     }));
    //   })
    // );
  }
}

export const AUTH_INTERCEPTOR_PROVIDER: Provider = {
  provide: HTTP_INTERCEPTORS,
  useClass: AuthInterceptor,
  multi: true,
} as const;
